import * as types from '../constants/ActionTypes';
import page from '../../lib/page';

import { trackLink } from '../../lib/analytics-helper';

const contentGlobalContainer = page.getGlobalContainer();
const indexClass = ' display-index';

// Update the z-index of vx_foreground-container className
function appendIndexClass() {
  if (contentGlobalContainer.length > 0) {
    contentGlobalContainer[0].className += indexClass;
  }
}

function removeIndexClass() {
  if (contentGlobalContainer.length > 0) {
    contentGlobalContainer[0].className.replace(indexClass, '');
  }
}

// Open and Close menu action
function mobileMenuOpen() {
  appendIndexClass();
  trackLink({ id: 'searchPage', link: 'smarthelp-search-filter|mobile|open' });
  return {
    type: types.OPEN_MOBILE_FILTER,
    payload: true,
  };
}

function mobileMenuClose() {
  removeIndexClass();
  trackLink({ id: 'searchPage', link: 'smarthelp-search-filter|mobile|close' });
  return {
    type: types.CLOSE_MOBILE_FILTER,
    payload: false,
  };
}

module.exports = {
  mobileMenuOpen,
  mobileMenuClose,
};
